import { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";

import WalletActionButtonAddBalanceModal from "./Modal";
import { useLocation } from "react-router-dom";
import { getPeymentedStatus } from "../../../../utils/paymented";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { getPlanWallet } from "../../../../redux/action/wallet/action";

const WalletActionButtonAddBalance = () => {
  const [showPayModal, setShowPayModal] = useState(false);
  const [showingPayModal, setShowingPayModal] = useState(false);
  const [shouldIncreasePrice, setShouldIncreasePrice] = useState();

  const walletPlanItems = useSelector((state) => state.wallet.walletPlan);
  const [cookies] = useCookies(["authToken"]);
  const dispatch = useDispatch();

  const location = useLocation();

  useEffect(() => {
    checkShouldIncreaseWallet();
    getPlanWalletHandler();

    return () => {
      if (document.body.classList.contains("modal-opened"))
        document.body.classList.remove("modal-opened");
    };
  }, []);

  const checkShouldIncreaseWallet = () => {
    const paymentStatus = getPeymentedStatus();

    if (!location.state?.increaseToWallet || paymentStatus) return;

    setShowingPayModal(true);
    setShowPayModal(true);

    setShouldIncreasePrice(location.state?.price);
  };

  const showModal = () => {
    document.body.classList.add("modal-opened");

    setShowPayModal(true);
  };

  const getPlanWalletHandler = async () => {
    const data = await dispatch(await getPlanWallet(cookies.authToken));
    if (data) {
      console.log(data);
    } else {
      toast.error(
        "مشکلی در دریافت پلن های کیف پول پیش آمده ، دوباره تلاش کنید !",
      );
    }
  };

  return (
    <>
      <button
        onClick={showModal}
        className="bg-white shadow-custom-lg rounded-xl p-4 flex items-center flex-col justify-center gap-4 !outline-none"
      >
        <div className="bg-white shadow-custom-md border-custom-gray border-2 w-14 h-14 rounded-full flex items-center justify-center">
          <ReactSVG
            className="text-primary w-8"
            src={`${process.env.PUBLIC_URL}/assets/images/icons/wallet-add.svg`}
          />
        </div>

        <span className="font-medium"> افزایش موجودی </span>
      </button>

      {showPayModal && (
        <WalletActionButtonAddBalanceModal
          showPayModal={showPayModal}
          showingPayModal={showingPayModal}
          onSetShowPayModal={setShowPayModal}
          onSetShowingPayModal={setShowingPayModal}
          shouldIncreasePrice={shouldIncreasePrice}
          OnSetShouldIncreasePrice={setShouldIncreasePrice}
          walletPlanItems={walletPlanItems}
        />
      )}
    </>
  );
};

export default WalletActionButtonAddBalance;
